import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { Modal } from "react-bootstrap";
import parse from "html-react-parser";
import { toast } from "react-toastify";

import {
  cardUpgradeData,
  paymentSuccessfulData,
} from "../ImageAndDataPopUp/DataContent";
import { toastResponse } from "../../Toast/Toast";
import GetFromServer from "../../../../utils/GetFromServer";

import "./imageAndDataPopUp.scss";
import { formatCategoryName } from "../../../Bank/report/widget/widgetsCommonFunction";
import { LogOut } from "../../../../Redux/authSlice";
import moment from "moment";
import { setLoaderFalse } from "../../../../Redux/loaderSlice";
import { getFormattedDateType1 } from "../../../Bank/CampaignManagement/campaignConstant";
import { SUBSCRIPTION } from "../../../../utils/global";

export const ImageAndDataPopUp = ({
  onHide = () => { },
  show,
  modalData,
  triggredFrom,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state.authReducer);
  const userRole = authReducer?.userData?.role?.toLowerCase();
  const showLogoutButton = modalData?.showLogoutButton || false;
  const [popupData, setPopupData] = useState(modalData);
  const [loading, setLoading] = useState(false);
  const [queryParams, _] = useSearchParams();
  const payment_successful = queryParams.get("payment_successful");
  const { data: maintenanceData, isLoading } = useSelector(
    (state) => state?.maintenanceReducer?.maintenanceData,
  );
  const trialEndTimeStamp = useSelector(
    (state) => state?.stripeReducer?.acknowledgement?.trial_end,
  );

  const timestampUTC =
    trialEndTimeStamp != null
      ? moment.unix(trialEndTimeStamp).utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
      : null;

  const handleClick = async () => {
    // if (modalData.cardName.toLowerCase() === "insights and strategy") {
    //   navigate(`/user/pricingTable`);
    // } else {
    let existing = authReducer?.userData?.subscriptionName;

    let involved =
      existing === "Freemium"
        ? "Pro"
        : existing === "Pro"
          ? "Marketing"
          : "Pro";
    setLoading(true);
    try {
      const response = await GetFromServer(
        `/client/pro/request?vFeature=${triggredFrom ? triggredFrom : formatCategoryName(popupData.cardName)
        }&vExistingTier=${existing}&vInvolvedTier=${involved}`,
        {},
      );
      if (response.data.status === "SUCCESS") {
        setPopupData(cardUpgradeData?.find((i) => i.cardName === "sales_contacted_successfully"));
        //     showToast("Email sent to sales team successfully.", "success");
        //     onHide();
      }
    } catch (error) {
      // showToast(error?.data?.message, "error");
      toast.error(toastResponse("error", error?.data?.message));
    }
    // props.onHide();
    setLoading(false);
    // }
  };
  return (
    <Modal
      className="imageAndDataPopup"
      show={show}
      onHide={() => {
        onHide();
      }}
      size={`${modalData.cardName.toLowerCase() === "upgrade_to_autopilot_profit" ? "xl" : "lg"}`}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="p-0">
        <div className="d-flex ">
          <div className="w-50">
            <img
              src={popupData?.popupImage}
              alt=""
              className="h-100"
              style={{
                borderTopLeftRadius: "10px",
                borderBottomLeftRadius: "10px",
              }}
            />
          </div>
          <div className="popup_details_block">
            <div>
              <button
                type="button"
                className={
                  popupData.cardName === paymentSuccessfulData.cardName
                    ? "d-none"
                    : "d-block close btn-close float-end"
                }
                // className="close btn-close float-end"
                aria-label="Close"
                onClick={() => {
                  onHide();
                }}
              >
                <span aria-hidden="true" className="visually-hidden">
                  &times;
                </span>
              </button>
            </div>

            <label
              style={{
                marginTop:
                  popupData?.cardName?.toLowerCase() === "insights and strategy"
                    ? "0"
                    : "1.154rem",
              }}
            >
              {popupData?.popupHeader}
            </label>
            <div
              className={
                popupData?.cardName?.toLowerCase() === "insights and strategy"
                  ? "popupDesc EWIpopupDesc"
                  : popupData?.cardName?.toLowerCase() ===
                    "sales_contacted_successfully"
                    ? "popupDesc contactSuccess" // Add the appropriate class for this condition
                    : "popupDesc"
              }
            >
              {parse(String(popupData?.popupDescription || ""))}
            </div>
            {popupData?.showTrialPeriod &&
              timestampUTC &&
              payment_successful !== "true" && (
                <div className="popupDesc">
                  <br />
                  <p>
                    Your subscription ends on{" "}
                    {getFormattedDateType1(timestampUTC)} !
                  </p>
                </div>
              )}
            {popupData?.showUpgradeButton &&
              userRole !== "reseller" &&
              userRole !== "bond-admin" &&
              authReducer?.userData?.subscription !== SUBSCRIPTION.PRO && (
                <button
                  type="button"
                  style={{ marginTop: "2.625rem" }}
                  onClick={() => handleClick()}
                  className="btn btn-other btn-bond fw-bolder btn-lg btn-popup"
                >
                  <span className="fs-btn-text fw-normal">
                    {/* {popupData?.cardName?.toLowerCase() ===
                    "insights and strategy"
                      ? "Upgrade Now"
                      : "Contact Sales"} */}
                    {/* Contact Sales */}
                    Upgrade to Autopilot Profit
                  </span>
                  <i
                    className="spinner-grow spinner-grow-sm ms-3"
                    id="btn_spinner"
                    role="status"
                    style={{ display: loading ? "inline-flex" : "none" }}
                  />
                </button>
              )}

            {showLogoutButton &&
              (maintenanceData?.is_downtime ||
                (userRole !== "reseller" && userRole !== "bond-admin")) && (
                <button
                  type="button"
                  style={{ marginTop: "2.625rem" }}
                  onClick={async () =>
                    await dispatch(LogOut())
                      .unwrap()
                      .then(() => {
                        dispatch(setLoaderFalse());
                        navigate("/user/login");
                      })
                      .catch((err) => {
                        dispatch(setLoaderFalse());
                      })
                  }
                  className="btn btn-other btn-bond fw-bolder btn-lg btn-popup"
                >
                  <span className="fs-btn-text fw-normal">Sign out</span>
                  <i
                    className="spinner-grow spinner-grow-sm ms-3"
                    id="btn_spinner"
                    role="status"
                    style={{ display: loading ? "inline-flex" : "none" }}
                  />
                </button>
              )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
